var _style, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContratosEAdendos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 40.4",
    style: {
      enableBackground: "new 0 0 35 40.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#707070;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2056",
    x: 3,
    y: 2.4,
    className: "st0",
    width: 32,
    height: 38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2229",
    className: "st1",
    d: "M30.3,7.1v18.1H22v10.1H7V7.1H30.3 M30.3,3.1H7c-1.8,0-3.3,1.8-3.3,4v28.2c0,2.2,1.5,4,3.3,4 h16.6l10-12.1V7.1C33.6,4.9,32.1,3.1,30.3,3.1z M18.7,25.2h-8.3v-4h8.3V25.2z M27,17.2H10.3v-4H27V17.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratosEAdendos);
export default __webpack_public_path__ + "static/media/Contratos_e_adendos.088d0d701e6845ea518fd4d983167ec2.svg";
export { ForwardRef as ReactComponent };